import { combineReducers } from 'redux';

import discardReasons from './discardReasons';
import form from './form';
import onReview from './onReview';
import selected from './selected';

export default combineReducers({
  discardReasons,
  form,
  onReview,
  selected,
});

export const getReportedIncidents = state => state.tasks.reportedIncidents;

export const getReportedIncidentsDiscardReasons = state =>
  state.tasks.reportedIncidents.discardReasons.response?.data || [];

export const getReportedIncidentsDiscardReasonsIsLoading = state =>
  state.tasks.reportedIncidents.discardReasons.isLoading;

export const getReportedIncidentsSelectedDiscardReason = state => {
  const selectedReasonId = state.tasks.reportedIncidents.selected.discardReason;
  const reasons = getReportedIncidentsDiscardReasons(state);

  if (selectedReasonId) {
    return (
      reasons.find(
        reason => reason.incidentDiscardedReasonId === selectedReasonId
      ) || null
    );
  }
  return null;
};
